import { render, staticRenderFns } from "./TagWithDotDotDot.vue?vue&type=template&id=375db158&"
import script from "./TagWithDotDotDot.vue?vue&type=script&lang=js&"
export * from "./TagWithDotDotDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports